import { render, staticRenderFns } from "./role_z.vue?vue&type=template&id=3adf7c9c&scoped=true"
import script from "./role_z.vue?vue&type=script&lang=js"
export * from "./role_z.vue?vue&type=script&lang=js"
import style0 from "./role_z.vue?vue&type=style&index=0&id=3adf7c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf7c9c",
  null
  
)

export default component.exports